import { render, staticRenderFns } from "./RegisterStudy.vue?vue&type=template&id=451bd876"
import script from "./RegisterStudy.vue?vue&type=script&lang=js"
export * from "./RegisterStudy.vue?vue&type=script&lang=js"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./RegisterStudy.vue?vue&type=style&index=1&id=451bd876&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports